/*
    # Tixly
    
    ## Description:
    Tixly is a ticketing platform that allows you to sell tickets to your events online.
    

    # Reference: 
    https://support.tixly.com/hc/en-us/articles/360018943458-Website-integration

*/

import React, { useEffect } from "react";
import { TixUserData } from "./Tixly.model";
import { connect } from "react-redux";
import { AppState, AppThunkDispatch } from "../../../store";
import { updateLoggedInStatus, updateBasketCountAsync } from "../../../store/tixly/actions";
import { getBasketCount, getLoggedInStatus } from "../../../store/tixly";

const TixlyLoader: React.FC<TixlyLoaderProps> = (props) => {
    const { updateBasketCount, updateLoggedInStatus } = props;
    const iframeRef = React.useRef<HTMLIFrameElement>(null);

    const handler = (ev: MessageEvent<TixUserData>) => {
        if (ev.origin !== "https://billet.aarhusteater.dk") return;
        if (typeof ev.data !== "object") return;

        const count = ev.data?.order?.items?.length ?? 0;
        const isLoggedIn = ev.data?.user !== null;

        updateBasketCount(count);
        updateLoggedInStatus(isLoggedIn);
    };

    useEffect(() => {
        if (!iframeRef.current) return;
        window.addEventListener("message", handler);
        return () => window.removeEventListener("message", handler);
    }, [iframeRef]);

    const onFrameLoaded = () => {
        if (!iframeRef.current) return;
        iframeRef.current.contentWindow?.postMessage("GetSession", "*");
    };

    return (
        <div>
            <iframe src="https://billet.aarhusteater.dk/da/itix" key={`userActionHiddenIframe_0`} title="UserSession Iframe" ref={iframeRef} security="restricted" hidden={true} onLoad={onFrameLoaded}></iframe>
        </div>
    );
};

type TixlyLoaderProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: AppState) => {
    return {
        basketCount: getBasketCount(state.tixly),
        isLoggedIn: getLoggedInStatus(state.tixly),
    };
};
const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    updateBasketCount: (count: number) => dispatch(updateBasketCountAsync(count)),
    updateLoggedInStatus: (isLoggedIn: boolean) => dispatch(updateLoggedInStatus(isLoggedIn)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TixlyLoader);
